import { styled } from '@mui/material/styles';
import { getIdvThemeTokens } from '../themeTokens';

export const HeaderRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 20,
  [theme.breakpoints.down(760)]: {
    alignItems: 'stretch',
    flexDirection: 'column',
  },
}));

export const TitleGroup = styled('div')({
  minWidth: 0,
});

export const Eyebrow = styled('p')(({ theme }) => ({
  margin: '0 0 4px',
  color: getIdvThemeTokens(theme).textMuted,
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
}));

export const Title = styled('h2')(({ theme }) => ({
  margin: '0 0 4px',
  fontSize: 19,
  fontWeight: 700,
  lineHeight: 1.2,
  color: getIdvThemeTokens(theme).text,
}));

export const Subhead = styled('p')(({ theme }) => ({
  margin: 0,
  color: getIdvThemeTokens(theme).textMuted,
  fontSize: 13,
  lineHeight: 1.45,
}));

export const ActionsSlot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  gap: 10,
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  flexShrink: 0,
  [theme.breakpoints.down(760)]: {
    justifyContent: 'flex-start',
  },
}));
